import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepLabel, Step, Stepper, Stack, useTheme, Typography } from '@mui/material'

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg,' + theme.palette.primary.main + '00' + ',' + theme.palette.primary.main + '80' + ',' + theme.palette.primary.main + 'FF' + ')',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg,' + theme.palette.primary.main + '00' + ',' + theme.palette.primary.main + '80' + ',' + theme.palette.primary.main + 'FF' + ')',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: '#F5F5F7',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        backgroundImage:
            'linear-gradient( 136deg, ' + theme.palette.primary.main + '00' + ', ' + theme.palette.primary.main + '80' + ', ' + theme.palette.primary.main + 'FF' + ')',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        // backgroundImage:
        //     'linear-gradient( 136deg, ' + theme.palette.primary.main + '00' + ', ' + theme.palette.primary.main + '80' + ', ' + theme.palette.primary.main + 'FF' + ')',
        backgroundColor: theme.palette.primary.main
    }),
}));

function ColorlibStepIcon(props) {
    const { steps, active, completed, className } = props;
    const { palette } = useTheme();
    let index = String(props.icon) - 1;
    if (index < 0) {
        index = 0;
    }
    let Icon = steps[index] ? steps[index].icon : undefined;
    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            <Icon color={!active && !completed ? palette.primary.main + '80' : undefined} />
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
};


export default function StepsComponent(props) {
    const { steps, active, isError, message, stepError } = props;
    const { palette } = useTheme();
    console.log('message:', message);
    console.log('isError:', isError);
    console.log('stepError:', stepError);
    return (
        <Stack sx={{ width: '100%' }} spacing={4}>
            <Stepper alternativeLabel activeStep={active} connector={<ColorlibConnector />}>
                {steps.map((item, index) => {
                    console.log('index:', index);
                    const labelProps = {};
                    if (stepError == index && isError) {
                        labelProps.optional = (
                            <Typography variant="subtitle2" color="error">
                                {message}
                            </Typography>
                        );
                        labelProps.error = true;
                    } else {
                        if (active > index) {
                            labelProps.optional = (
                                <Typography variant="subtitle2" sx={{ color: palette.success.main }}>
                                    {"Completed"}
                                </Typography>
                            );
                        }
                    }
                    return (
                        <Step key={item.id}>
                            <StepLabel {...labelProps} StepIconComponent={ColorlibStepIcon} StepIconProps={{ steps: steps }}>{item.label}</StepLabel>
                        </Step>
                    )
                })}
            </Stepper>
        </Stack>
    );
}